export enum AuthStatus {
  AuthenticationRequested = 'AUTHENTICATION_REQUESTED',
  AuthenticationSuccess = 'AUTHENTICATION_SUCCESS',
  AuthenticationError = 'AUTHENTICATION_ERROR',
}
